import {
    SET_RESPONSE_GROUP_FILTERS,
    CLEAR_RESPONSE_GROUP_FILTERS
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case SET_RESPONSE_GROUP_FILTERS:
        return{
          ...state,
          groups: {
            filters: {...state.groups.filters, ...action.data}
          }
        }
      case CLEAR_RESPONSE_GROUP_FILTERS:
        return{
          ...state,
          groups: {
            filters: {}
          }
        }
      default:
        return state;
    }
  }